import _ from 'lodash'

export const isLogedUser = state => _.size(_.get(state, 'auth.token')) > 0

export const isUnauthorizedError = error => _.get(error, 'response.data.code') === 401 || _.get(error, 'response.status') === 401
